/* eslint-disable no-console */
export type LogLevel = 'debug' | 'info' | 'warn' | 'error' | 'silent';

const LEVELS: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
  silent: 4,
};

export class Logger {
  private level: number;

  constructor(level: LogLevel = 'warn') {
    this.level = LEVELS[level];
  }

  setLevel(level: LogLevel): void {
    this.level = LEVELS[level];
  }

  debug(message: string, ...args: unknown[]): void {
    if (this.level <= LEVELS.debug) {
      console.debug(`[Spectrum SDK] ${message}`, ...args);
    }
  }

  info(message: string, ...args: unknown[]): void {
    if (this.level <= LEVELS.info) {
      console.info(`[Spectrum SDK] ${message}`, ...args);
    }
  }

  warn(message: string, ...args: unknown[]): void {
    if (this.level <= LEVELS.warn) {
      console.warn(`[Spectrum SDK] ${message}`, ...args);
    }
  }

  error(message: string, ...args: unknown[]): void {
    if (this.level <= LEVELS.error) {
      console.error(`[Spectrum SDK] ${message}`, ...args);
    }
  }
}
